import * as PubNub from 'pubnub';
import { ITimerOptions } from './TimerOptions';

class MessageService {

  private pubnub: PubNub = new PubNub({
    publishKey: 'pub-c-026f1e6b-20f9-42bd-af79-859ce7cfbc15',
    subscribeKey: 'sub-c-7c16721c-8aaa-11e9-868c-ca8113a73965'
  });

  private listener: PubNub.ListenerParameters;

  public subscribe(timerCode: number, listener: (options: ITimerOptions) => void) {
    this.unsubscribe();
    this.pubnub.history(
      {
        channel: timerCode.toString(),
        count: 1
      },
      (status, response) => {
        if (response.messages.length > 0) {
          const msg = response.messages[0].entry as ITimerOptions;
          if ((msg.startedMs + msg.duration) > new Date().getTime()) {
            listener(msg);
          }
        }
      }
    );
    this.listener = {
      message: (message) => {
        listener(message.message as ITimerOptions);
      }
    };
    this.pubnub.addListener(this.listener);
    this.pubnub.subscribe({
      channels: [timerCode.toString()]
    });
  }

  public unsubscribe() {
    if (this.listener) {
      this.pubnub.unsubscribeAll();
      this.pubnub.removeListener(this.listener);
    }
  }

  public shareTimer(options: ITimerOptions) {
    if (!options.timerCode) {
      throw new Error("TimerCode not set");
    }
    this.pubnub.publish({
      channel: options.timerCode.toString(),
      message: options
    });
  }
}

export default new MessageService();


// WEBPACK FOOTER //
// ./src/Timer/MessageService.ts